import axiosClient from "../axiosClient";

const PREFIX_URL = "crm/mau-hop-dong";

const referenceContractApi = {
    getFilter: (params) => {
        const url = `${PREFIX_URL}/index`;
        return axiosClient.get(url, { params });
    },
    getAll: (params) => {
        const url = `${PREFIX_URL}/getAll`;
        return axiosClient.get(url, { params });
    },
    getById: (params) => {
        const url = `${PREFIX_URL}/getById`;
        return axiosClient.get(url, { params });
    },
    getFile: (params) => {
        const url = `${PREFIX_URL}/getFile`;
        return axiosClient.get(url, { params });
    },
    getBase64: (params) => {
        const url = `${PREFIX_URL}/getBase64`;
        return axiosClient.get(url, { params });
    },
    upload: (data) => {
        const url = `${PREFIX_URL}/upload`;
        return axiosClient.post(url, data);
    },
    create: (data) => {
        const url = `${PREFIX_URL}/create`;
        return axiosClient.post(url, data);
    },
    update: (data) => {
        const url = `${PREFIX_URL}/update`;
        return axiosClient.post(url, data);
    },
    delete: (data) => {
        const url = `${PREFIX_URL}/delete`;
        return axiosClient.post(url, data);
    },
    deleteMultiple: (data) => {
        const url = `${PREFIX_URL}/deleteMultiple`;
        return axiosClient.post(url, data);
    },
    saveFields: (data) => {
        const url = `${PREFIX_URL}/save-fields`;
        return axiosClient.post(url, data);
    },
    saveInfo: (data) => {
        const url = `${PREFIX_URL}/save-info`;
        return axiosClient.post(url, data);
    },
    getPreviewByVariablesUpload: (data) => {
        const url = `${PREFIX_URL}/getPreviewByVariablesUpload`;
        return axiosClient.post(url, data);
    },
    getPreviewByVariables: (data) => {
        const url = `${PREFIX_URL}/getPreviewByVariables`;
        return axiosClient.post(url, data);
    },
}

export default referenceContractApi;
